module.exports = __webpack_public_path__ + "static/media/format.c8dc362b.svg";